export const tagPanelAction = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_TAGPANEL", data: param });
  }
};